export default __webpack_public_path__ + "images/247c34e8387dbd4a0b1f3844d54de955-cc-mini-front.png";